
import React from 'react';
import { Route, Routes } from "react-router-dom";
import { useState, useEffect, useRef } from 'react';
import {jwtDecode} from "jwt-decode"; // Adjust import if needed
import LoginPage from "../components/LoginPage";
import DaneDatesLising from "../components/DaneDatesLising";
import { useContext } from 'react';
import { AppContext } from "../components/context/AppContext";
import TenantListing from '../components/TenantsAdministration/TenantListing';
import PublicDaneDatesLisingView from '../components/PublicDaneDatesLisingView';
import DonorListing from '../components/Donors/DonorListing';
import AdminMenu from '../components/Administration/AdminMenu';
import DaneCountReport from '../components/Reports/DaneCountReport';

const Router = () => {
  const { setToken, setUser, currentUser, setLoadingApp } = useContext(AppContext);
  const [error, setError] = useState(null); 
  const dataFetchedRef = useRef(false);

  const getUserToken = async () => {
    try {
      const value = localStorage.getItem(process.env.REACT_APP_API_AUTH_TOKEN);
     
      if (value) {
        console.log("Token found in storage.");
        const decodedToken = jwtDecode(value);
        const tokenExpired = isTokenExpired(decodedToken);

        if (tokenExpired) {
          console.log("Token has expired.");
          localStorage.clear();  
          setUser(null);
          setToken(null);      
        } else {
          console.log("Token is still valid.");
          setUser(decodedToken);
          setToken(value);
        }
      }
    } catch (e) {
      console.log(e);
      setError(e);
    } finally {
      setLoadingApp(false);
    }
  };

  const isTokenExpired = (token) => {
    if (!token || !token.exp) {
      return true;
    }
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return currentTimestamp > token.exp;
  };

  useEffect(() => {
    if (!dataFetchedRef.current) {
      getUserToken();
      dataFetchedRef.current = true;
    }

    console.log(currentUser);
  }, [currentUser]);

  return (
    <>
      {/* Anonymous access for certain routes */}
      <Routes>
        <Route path="/view/wales" element={<PublicDaneDatesLisingView tenantId="WAL003" tenantName="Wales" tenantAddress="Willenhall St, Newport NP19 0GE, United Kingdom" />} />         
        <Route path="/view/london" element={<PublicDaneDatesLisingView tenantId="LDN001" tenantName="London" tenantAddress="56, Vernon Dr, Stanmore, HA7 2BT" />} />
        <Route path="/view/basildon" element={<PublicDaneDatesLisingView tenantId="BSL002" tenantName="Basildon" tenantAddress="Dhamma land,Hardings Elms Road,Crays Hill, BILLERICAY, Essex, CM11 2UH" />} />
        {/* Protected routes: Check if currentUser is available */}
        {!currentUser ? (
          <Route path="*" element={<LoginPage />} />
        ) : (
          <>
          {/* <Route path="/" element={<DaneDatesLising />} /> */}
            {(currentUser.accesstype !== "admin" && currentUser.accesstype !== "superadmin" ) && <Route path="/" element={<DaneDatesLising />} />}
             {(currentUser.accesstype === "admin" || currentUser.accesstype === "superadmin" ) && <Route path="/" element={<AdminMenu />} />}
            <Route path="/orgsetup" element={<TenantListing />} />
            <Route path="/donors" element={<DonorListing />} />
            <Route path="/danedates" element={<DaneDatesLising />} />
            <Route path="/report/danecount" element={<DaneCountReport/>} />
          </>
        )}
      </Routes>
    </>
  );
};

export default Router;


// import React  from 'react'
// import { Route, Routes } from "react-router-dom";
// import { useState, useEffect, useRef } from 'react';
// import { jwtDecode } from "jwt-decode";
// import LoginPage from "../components/LoginPage";
// import DaneDatesLising from "../components/DaneDatesLising";
// import { useContext } from 'react';
// import { AppContext } from "../components/context/AppContext";
// import TenantListing from '../components/TenantsAdministration/TenantListing';
// import PublicDaneDatesLisingView from '../components/PublicDaneDatesLisingView';


// const Router = () => {
//   const { setToken, setUser, currentUser, setLoadingApp } = useContext(AppContext);
//   const [error, setError] = useState(null); 
//   const dataFetchedRef = useRef(false);

//   const getUserToken = async () => {
//     try {
//       const value = localStorage.getItem(process.env.REACT_APP_API_AUTH_TOKEN);
     
//       if (value) {
//         console.log("there saved token");
//         const decodedToken = jwtDecode(value);
//         const tokenExpired = isTokenExpired(decodedToken);

//         if (tokenExpired) {
//           console.log("Token has expired.");
//           localStorage.clear();  
//           setUser(null);
//           setToken(null);      
//         } else {
//           console.log("Token is still valid.");
//           setUser(decodedToken);
//           setToken(value);
//         }
//       }
//     } catch (e) {
//       console.log(e);
//       setError(e);
//     } finally {
//       setLoadingApp(false);
//     }
//   };

//   const isTokenExpired = (token) => {
//     if (!token || !token.exp) {
//       return true;
//     }
//     const currentTimestamp = Math.floor(Date.now() / 1000);
//     return currentTimestamp > token.exp;
//   };

//   useEffect(() => {
//     if (!dataFetchedRef.current) {
//       getUserToken();
//       dataFetchedRef.current = true;
//     }

//       console.log(currentUser);

//   }, []);

//   return (
//     <>
//       {!currentUser ? <LoginPage /> : 
//       <Routes>        
//           <Route path="/" element={<DaneDatesLising />} />         
//           {/* <Route path="/view/wales" element={<PublicDaneDatesLisingView tenantId="1" tenantName="Wales" tenantAddress="164 ,Ynysddu, Pontyclun, CF72 9UD" />} />         
//           <Route path="/view/london" element={<PublicDaneDatesLisingView tenantId="2" tenantName="London" tenantAddress="56, Vernon Dr, Stanmore, HA7 2BT"  />} />          */}
//           <Route path="/view/wales"  element={<PublicDaneDatesLisingView tenantId="WAL003" tenantName="Wales" tenantAddress="164 ,Ynysddu, Pontyclun, CF72 9UD" />} />         
//           <Route path="/view/london" element={<PublicDaneDatesLisingView tenantId="LDN001" tenantName="London" tenantAddress="56, Vernon Dr, Stanmore, HA7 2BT"  />} />         
//           <Route path="/orgsetup" element={<TenantListing />} />         
//       </Routes>
//       }
//     </>
//   );
// };

// export default Router;

